import { defineNuxtPlugin } from "#app";
import axios from "axios";
import { useUserStore } from "~/stores/userstore";

export default defineNuxtPlugin(async (_unusedApp) => {
  const userStore = useUserStore();

  console.debug("auth.client.ts loaded");

  try {
    console.debug("Authenticating user...");
    const request = new XMLHttpRequest();
    //@ts-expect-error Url is globally defined and loaded in head - /service/api/js/urls
    request.open("GET", Url.Users_Jwt_Create, false); // `false` makes the request synchronous
    request.send(null);
    if (request.status === 200 || request.status === 201) {
      const result = request.responseText;
      console.debug("Users_Jwt_Create: " + result);
      //@ts-expect-error Url is globally defined and loaded in head - /service/api/js/urls
      const { data: userIsAuth } = await axios.get(Url.Users_Jwt_Info);
      console.debug("Users_Jwt_Info: " + JSON.stringify(userIsAuth));
      if (userIsAuth) {
        userStore.setAuth(userIsAuth.uuid);
        console.debug("User authenticated");
      } else {
        userStore.clearAuth();
      }
    }
  } catch (error) {
    console.error("Error during authentication", error);
    userStore.clearAuth();
  }
});
